import { Component, inject, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { formatMediumDateTime } from 'rev-shared/date/DateFormatters';

import { JobStatus } from 'rev-shared/media/IAutoIngestJobInfo';
import { IVbUiDataGridColDef } from 'rev-shared/ui/dataGrid/columns/IVbUiDataGridColDef';

import styles from './MediaFeatures.module.less';

const statusFormatMap = {
	[JobStatus.Failed]: 'Error',
	[JobStatus.Finished]: 'Success',
	[JobStatus.PartiallyFinished]: 'Partial',
	[JobStatus.Postponed]: 'Media_Integrations_AutoIngest_ViewLog_Postponed',
	[JobStatus.Running]: 'Running'
};

@Component({
	selector: 'auto-ingest-logs-grid',
	templateUrl: './AutoIngestLogsGrid.Component.html',
	standalone: false
})
export class AutoIngestLogsGridComponent implements OnInit {
	@Input() public data: any[];

	public dateFormatter = params => formatMediumDateTime(params.value);
	public statusFormatter = params => this.formatStatus(params.value);
	public readonly styles = styles;

	private statusTranslations: { [key: string]: string };
	private readonly Translate = inject(TranslateService);
	public columnDefs: IVbUiDataGridColDef[];

	public ngOnInit(): void {
		this.statusTranslations = this.Translate.instant(Object.values(statusFormatMap));
		this.assignColumnDefs();
	}

	public formatStatus(status: JobStatus): string {
		const translationKey: string = statusFormatMap[status];

		return this.statusTranslations[translationKey];
	}

	private assignColumnDefs(): void {
		this.columnDefs = [
			{
				field: 'whenRequested',
				headerName: this.Translate.instant('Media_Integrations_AutoIngest_ViewLog_Date'),
				valueFormatter: this.dateFormatter
			},
			{
				field: 'processedRecordings',
				headerName: this.Translate.instant('Media_Integrations_AutoIngest_ViewLog_Imported')
			},
			{
				field: 'remainingRecordings',
				headerName: this.Translate.instant('Media_Integrations_AutoIngest_ViewLog_Postponed')
			},
			{
				field: 'status',
				headerName: this.Translate.instant('Media_Integrations_AutoIngest_ViewLog_Status'),
				valueFormatter: this.statusFormatter
			},
			{
				field: 'jobDetails',
				headerName: this.Translate.instant('Media_Integrations_AutoIngest_ViewLog_Details')
			}
		];
	}
}
